(() => {
  'use strict';

  const ROOT = window.Shopify?.routes?.root || '/';

  const getCart = async () => {
    const response = await fetch(`${ROOT}cart.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error(`Could not read cart (${response.status})`);
    }

    return response.json();
  };

  const syncOneHorizonCartIcon = (cartIcon, count) => {
    if (!cartIcon) return;

    const bubble =
      cartIcon.querySelector('.cart-bubble');

    const countNode =
      cartIcon.querySelector('[ref="cartBubbleCount"]') ||
      cartIcon.querySelector('.cart-bubble__text-count') ||
      cartIcon.querySelector('[data-testid="cart-bubble"]');

    if (bubble) {
      bubble.classList.toggle(
        'visually-hidden',
        count === 0
      );

      bubble.hidden = count === 0;

      if (count > 0) {
        bubble.removeAttribute('hidden');

        bubble.setAttribute(
          'aria-hidden',
          'false'
        );
      }
    }

    if (countNode) {
      countNode.textContent =
        count > 99
          ? ''
          : String(count);

      countNode.classList.toggle(
        'hidden',
        count === 0
      );

      countNode.hidden =
        count === 0;

      if (count > 0) {
        countNode.removeAttribute(
          'hidden'
        );

        countNode.setAttribute(
          'aria-hidden',
          'true'
        );
      }
    }

    cartIcon.classList.toggle(
      'header-actions__cart-icon--has-cart',
      count > 0
    );
  };

  const syncAllKnownCounters = (count) => {
    document
      .querySelectorAll('cart-icon')
      .forEach((cartIcon) => {
        syncOneHorizonCartIcon(
          cartIcon,
          count
        );
      });

    document
      .querySelectorAll(
        '.theme-drawer__badge'
      )
      .forEach((node) => {
        node.textContent =
          String(count);

        node.classList.toggle(
          'visually-hidden',
          count === 0
        );

        node.hidden =
          count === 0;

        if (count > 0) {
          node.removeAttribute(
            'hidden'
          );
        }
      });

    document
      .querySelectorAll(
        '[ref="cartItemCount"]'
      )
      .forEach((node) => {
        node.textContent =
          String(count);
      });

    document
      .querySelectorAll(
        [
          '[data-cart-count]',
          '[data-cart-count-bubble]',
          '[data-cart-count-text]',
          '.header__cart-count',
          '.cart-count'
        ].join(',')
      )
      .forEach((node) => {
        if (
          node.children &&
          node.children.length > 0
        ) {
          return;
        }

        node.textContent =
          String(count);

        node.classList.toggle(
          'visually-hidden',
          count === 0
        );

        node.hidden =
          count === 0;

        if (count > 0) {
          node.removeAttribute(
            'hidden'
          );
        }
      });
  };

  window.athletixSyncHorizonCart =
    async (
      providedCart = null
    ) => {
      try {
        const cart =
          providedCart ||
          await getCart();

        const count =
          Number(
            cart?.item_count || 0
          );

        syncAllKnownCounters(
          count
        );

        document
          .querySelectorAll(
            'header-actions [ref="liveRegion"], [data-testid="cart-count-live-region"]'
          )
          .forEach((node) => {
            node.textContent =
              count > 0
                ? `${count} item${count === 1 ? '' : 's'} in cart`
                : 'Cart is empty';
          });

        document.dispatchEvent(
          new CustomEvent(
            'athletix:cart-updated',
            {
              bubbles: true,
              detail: cart
            }
          )
        );

        return cart;

      } catch (error) {
        console.warn(
          '[ATHLETIX] Horizon cart counter sync failed',
          error
        );

        return null;
      }
    };

  const initialize = () => {
    window
      .athletixSyncHorizonCart
      ?.();
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {
    initialize();
  }

  document.addEventListener(
    'shopify:section:load',
    initialize
  );

})();


(() => {
  'use strict';

  const ROOT_SELECTOR =
    '[data-athpp]';


  const moneyFallback =
    (
      cents,
      currency = 'USD'
    ) => {

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang ||
          'en',
          {
            style: 'currency',
            currency
          }
        ).format(
          (Number(cents) || 0) / 100
        );

      } catch {
        return `$${(
          (Number(cents) || 0) /
          100
        ).toFixed(2)}`;
      }
    };


  const parseVariants =
    (root) => {

      const node =
        root.querySelector(
          '[data-athpp-variants]'
        );

      if (!node) {
        return [];
      }

      try {
        return JSON.parse(
          node.textContent ||
          '[]'
        );

      } catch (error) {
        console.error(
          '[ATHLETIX] Could not parse variants',
          error
        );

        return [];
      }

    };


  const init =
    (root) => {

      if (
        !root ||
        root.dataset
          .athppCartInitialized ===
          'true'
      ) {
        return;
      }

      root.dataset
        .athppCartInitialized =
        'true';


      const variants =
        parseVariants(root);


      if (!variants.length) {
        return;
      }


      const form =
        root.querySelector(
          '[data-athpp-form]'
        );


      const addButton =
        root.querySelector(
          '[data-athpp-add]'
        );


      const addLabel =
        root.querySelector(
          '[data-athpp-add-label]'
        );


      const message =
        root.querySelector(
          '[data-athpp-message]'
        );


      const quantityInput =
        root.querySelector(
          '[data-athpp-quantity]'
        );


      const mainPrice =
        root.querySelector(
          '[data-athpp-main-price]'
        );


      const total =
        root.querySelector(
          '[data-athpp-total]'
        );


      const totalDetail =
        root.querySelector(
          '[data-athpp-total-detail]'
        );


      const printToggle =
        root.querySelector(
          '[data-athpp-print-toggle]'
        );


      const customBody =
        root.querySelector(
          '[data-athpp-custom-body]'
        );


      const nameInput =
        root.querySelector(
          '[data-athpp-name]'
        );


      const numberInput =
        root.querySelector(
          '[data-athpp-number]'
        );


      /* ========================================================
         FAN / PLAYER VERSION
         Only exists on eligible products rendered by Liquid
      ======================================================== */

      const printVersionInputs = [
        ...root.querySelectorAll(
          '[data-athpp-print-version]'
        )
      ];


      const printVersionGroup =
        root.querySelector(
          '[data-athpp-print-version-group]'
        );


      const printVersionError =
        root.querySelector(
          '[data-athpp-print-version-error]'
        );


      const getSelectedPrintVersion =
        () => {

          return (
            printVersionInputs.find(
              (input) =>
                input.checked
            )?.value || ''
          );

        };


      printVersionInputs.forEach(
        (input) => {

          input.addEventListener(
            'change',
            () => {

              if (
                printVersionError
              ) {
                printVersionError.hidden =
                  true;
              }


              if (
                message &&
                message.textContent ===
                  'Please choose Fan Version or Player Version.'
              ) {
                message.textContent =
                  '';
              }

            }
          );

        }
      );


      const printPreview =
        root.querySelector(
          '[data-athpp-print-preview]'
        );


      const printName =
        root.querySelector(
          '[data-athpp-print-name]'
        );


      const printNumber =
        root.querySelector(
          '[data-athpp-print-number]'
        );


      const sleeves =
        root.querySelector(
          '[data-athpp-sleeves]'
        );


      const frontImage =
        root.querySelector(
          '[data-athpp-front-image]'
        );


      const backImage =
        root.querySelector(
          '[data-athpp-back-image]'
        );


      const currentView =
        root.querySelector(
          '[data-athpp-current-view]'
        );


      const previewHint =
        root.querySelector(
          '[data-athpp-preview-hint]'
        );


      const patchGroup =
        root.querySelector(
          '[data-athpp-patch-group]'
        );


      const currency =
        root.dataset.currency ||
        'USD';


      /* ========================================================
         NAME & NUMBER PRINTING ADD-ON
         Real Shopify add-on product supplied by Liquid.
      ======================================================== */

      const printAddonVariantId = 67827539312707;
      const printAddonPrice = 300;


      let submitting =
        false;


      let selectedVariant =
        variants[0];


      const optionContainers = [
        ...root.querySelectorAll(
          '[data-athpp-option-container]'
        )
      ];


      const getSelectedOptions =
        () => {

          return optionContainers.map(
            (container) => {

              const chipWrap =
                container.querySelector(
                  '[data-athpp-option-chips]'
                );


              if (chipWrap) {

                return (
                  chipWrap.querySelector(
                    '[data-athpp-option-value].is-selected'
                  )?.dataset
                    .athppOptionValue ||
                  ''
                );

              }


              return (
                container.querySelector(
                  '[data-athpp-option-select]'
                )?.value ||
                ''
              );

            }
          );

        };


      const findVariant =
        () => {

          const selected =
            getSelectedOptions();


          return (
            variants.find(
              (variant) => {

                return (
                  Array.isArray(
                    variant.options
                  ) &&

                  variant.options.length ===
                    selected.length &&

                  variant.options.every(
                    (
                      value,
                      index
                    ) =>
                      String(value) ===
                      String(
                        selected[
                          index
                        ]
                      )
                  )
                );

              }
            ) ||
            null
          );

        };


      const getQuantity =
        () => {

          const value =
            Math.max(
              1,
              Math.min(
                20,
                parseInt(
                  quantityInput?.value ||
                    '1',
                  10
                ) ||
                  1
              )
            );


          if (quantityInput) {

            quantityInput.value =
              String(value);

          }


          return value;
        };


      const selectedPatches =
        () => {

          return [
            ...root.querySelectorAll(
              '[data-athpp-patch]'
            )
          ]

            .filter(
              (patch) => {

                return patch
                  .querySelector(
                    '[data-athpp-patch-checkbox]'
                  )
                  ?.checked;

              }
            )

            .map(
              (patch) => ({
                element:
                  patch,

                variantId:
                  Number(
                    patch.dataset
                      .patchVariant ||
                      0
                  ),

                title:
                  patch.dataset
                    .patchTitle ||
                  'Patch',

                price:
                  Number(
                    patch.dataset
                      .patchPrice ||
                      0
                  ),

                sleeve:
                  patch.dataset
                    .patchSleeve ||
                  '',

                image:
                  patch.dataset
                    .patchImage ||
                  ''
              })
            )

            .filter(
              (patch) =>
                patch.variantId >
                0
            );

        };


      const isPersonalizationOn =
        () => {

          return (
            root.dataset
              .personalizationEnabled ===
              'true' &&

            root.dataset
              .backImageEnabled ===
              'true' &&

            printToggle
              ?.getAttribute(
                'aria-checked'
              ) ===
              'true'
          );

        };


      const updateTotal =
        () => {

          if (!selectedVariant) {
            return;
          }


          const quantity =
            getQuantity();


          const patches =
            selectedPatches();


          const jerseyPrice =
            Number(
              selectedVariant.price ||
              0
            );


          const patchPriceEach =
            patches.reduce(
              (
                sum,
                patch
              ) =>
                sum +
                patch.price,
              0
            );


          const printPriceEach =
            isPersonalizationOn()
              ? printAddonPrice
              : 0;


          const cents =
            (
              jerseyPrice +
              patchPriceEach +
              printPriceEach
            ) *
            quantity;


          if (total) {

            total.textContent =
              moneyFallback(
                cents,
                currency
              );

          }


          if (totalDetail) {

            const parts = [
              `${quantity} jersey${
                quantity === 1
                  ? ''
                  : 's'
              }`
            ];


            if (
              isPersonalizationOn()
            ) {

              parts.push(
                `name & number +${moneyFallback(
                  printAddonPrice * quantity,
                  currency
                )}`
              );

            }


            if (
              patches.length
            ) {

              parts.push(
                `${
                  patches.length
                } paid patch${
                  patches.length ===
                  1
                    ? ''
                    : 'es'
                } per jersey`
              );

            } else {

              parts.push(
                'no paid patches'
              );

            }


            totalDetail.textContent =
              parts.join(
                ' · '
              );

          }

        };


      const updateVariantUI =
        () => {

          const found =
            findVariant();


          if (!found) {

            selectedVariant =
              null;


            if (addButton) {

              addButton.disabled =
                true;

            }


            if (addLabel) {

              addLabel.textContent =
                'UNAVAILABLE';

            }


            if (message) {

              message.textContent =
                'This combination is unavailable.';

              message.classList.remove(
                'is-success'
              );

            }


            return;
          }


          selectedVariant =
            found;


          if (mainPrice) {

            mainPrice.textContent =
              found.formattedPrice ||
              moneyFallback(
                found.price,
                currency
              );

          }


          if (addButton) {

            addButton.disabled =
              !found.available ||
              submitting;

          }


          if (addLabel) {

            addLabel.textContent =
              found.available
                ? 'ADD TO CART'
                : 'UNAVAILABLE';

          }


          if (
            message &&
            !submitting
          ) {

            message.textContent =
              '';

          }


          updateTotal();

        };


      root
        .querySelectorAll(
          '[data-athpp-option-chips]'
        )
        .forEach(
          (wrap) => {

            wrap.addEventListener(
              'click',
              (event) => {

                const button =
                  event.target.closest(
                    '[data-athpp-option-value]'
                  );


                if (
                  !button ||
                  button.disabled
                ) {
                  return;
                }


                wrap
                  .querySelectorAll(
                    '[data-athpp-option-value]'
                  )
                  .forEach(
                    (item) => {

                      const selected =
                        item ===
                        button;


                      item.classList.toggle(
                        'is-selected',
                        selected
                      );


                      item.setAttribute(
                        'aria-pressed',
                        String(
                          selected
                        )
                      );

                    }
                  );


                const container =
                  wrap.closest(
                    '[data-athpp-option-container]'
                  );


                const current =
                  container
                    ?.querySelector(
                      '[data-athpp-current-option]'
                    );


                if (current) {

                  current.textContent =
                    button.dataset
                      .athppOptionValue ||
                    '';

                }


                updateVariantUI();

              }
            );

          }
        );


      root
        .querySelectorAll(
          '[data-athpp-option-select]'
        )
        .forEach(
          (select) => {

            select.addEventListener(
              'change',
              () => {

                const container =
                  select.closest(
                    '[data-athpp-option-container]'
                  );


                const current =
                  container
                    ?.querySelector(
                      '[data-athpp-current-option]'
                    );


                if (current) {

                  current.textContent =
                    select.value;

                }


                updateVariantUI();

              }
            );

          }
        );
              root
        .querySelector(
          '[data-athpp-decrease]'
        )
        ?.addEventListener(
          'click',
          () => {

            if (
              !quantityInput
            ) {
              return;
            }


            quantityInput.value =
              String(
                Math.max(
                  1,
                  getQuantity() -
                    1
                )
              );


            updateTotal();

          }
        );


      root
        .querySelector(
          '[data-athpp-increase]'
        )
        ?.addEventListener(
          'click',
          () => {

            if (
              !quantityInput
            ) {
              return;
            }


            quantityInput.value =
              String(
                Math.min(
                  20,
                  getQuantity() +
                    1
                )
              );


            updateTotal();

          }
        );


      quantityInput
        ?.addEventListener(
          'change',
          updateTotal
        );


      quantityInput
        ?.addEventListener(
          'input',
          updateTotal
        );


      const setView =
        (view) => {

          const isBack =
            view === 'back' &&
            !!backImage;


          if (frontImage) {

            frontImage.hidden =
              isBack;

          }


          if (backImage) {

            backImage.hidden =
              !isBack;

          }


          root
            .querySelectorAll(
              '[data-athpp-view]'
            )
            .forEach(
              (button) => {

                const active =
                  button.dataset
                    .athppView ===
                  (
                    isBack
                      ? 'back'
                      : 'front'
                  );


                button.classList.toggle(
                  'is-current',
                  active
                );


                button.setAttribute(
                  'aria-pressed',
                  String(
                    active
                  )
                );

              }
            );


          root
            .querySelectorAll(
              '[data-athpp-thumb-view]'
            )
            .forEach(
              (button) => {

                const active =
                  button.dataset
                    .athppThumbView ===
                  (
                    isBack
                      ? 'back'
                      : 'front'
                  );


                button.classList.toggle(
                  'is-selected',
                  active
                );


                button.setAttribute(
                  'aria-pressed',
                  String(
                    active
                  )
                );

              }
            );


          if (currentView) {

            currentView.textContent =
              isBack
                ? 'BACK VIEW'
                : 'FRONT VIEW';

          }


          if (printPreview) {

            printPreview.hidden =
              !(
                isBack &&
                isPersonalizationOn()
              );

          }


          if (sleeves) {

            sleeves.hidden =
              !isBack;

          }


          if (
            previewHint &&
            root.dataset
              .backImageEnabled ===
              'true'
          ) {

            previewHint.textContent =
              isBack
                ? 'Viewing back of jersey'
                : root.dataset
                    .personalizationEnabled ===
                    'true'
                ? 'Select BACK to preview personalizations'
                : 'Select BACK to view the back';

          }

        };


      root
        .querySelectorAll(
          '[data-athpp-view]'
        )
        .forEach(
          (button) => {

            button.addEventListener(
              'click',
              () =>
                setView(
                  button.dataset
                    .athppView
                )
            );

          }
        );


      root
        .querySelectorAll(
          '[data-athpp-thumb-view]'
        )
        .forEach(
          (button) => {

            button.addEventListener(
              'click',
              () =>
                setView(
                  button.dataset
                    .athppThumbView
                )
            );

          }
        );


      const renderPersonalization =
        () => {

          const enabled =
            isPersonalizationOn();


          if (customBody) {

            customBody.hidden =
              !enabled;

          }


          if (patchGroup) {

            patchGroup.hidden =
              !enabled;

          }


          if (printPreview) {

            const backSelected =
              root
                .querySelector(
                  '[data-athpp-view="back"]'
                )
                ?.getAttribute(
                  'aria-pressed'
                ) ===
                'true';


            printPreview.hidden =
              !(
                enabled &&
                backSelected
              );

          }


          if (!enabled) {

            if (printVersionError) {
              printVersionError.hidden =
                true;
            }


            root
              .querySelectorAll(
                '[data-athpp-patch-checkbox]'
              )
              .forEach(
                (box) => {

                  box.checked =
                    false;


                  box
                    .closest(
                      '[data-athpp-patch]'
                    )
                    ?.classList.remove(
                      'is-selected'
                    );

                }
              );


            if (sleeves) {

              sleeves.innerHTML =
                '';

            }

          }


          updateTotal();

        };


      printToggle
        ?.addEventListener(
          'click',
          () => {

            const next =
              printToggle
                .getAttribute(
                  'aria-checked'
                ) !==
              'true';


            printToggle.setAttribute(
              'aria-checked',
              String(
                next
              )
            );


            renderPersonalization();


            if (
              next &&
              backImage
            ) {

              setView(
                'back'
              );

            }

          }
        );


      const updatePrintText =
        () => {

          if (printName) {

            printName.textContent =
              (
                nameInput?.value ||
                ''
              )
                .trim()
                .toUpperCase() ||
              'YOUR NAME';

          }


          if (printNumber) {

            printNumber.textContent =
              (
                numberInput?.value ||
                ''
              )
                .replace(
                  /\D/g,
                  ''
                )
                .slice(
                  0,
                  2
                ) ||
              '10';

          }


          if (numberInput) {

            numberInput.value =
              (
                numberInput.value ||
                ''
              )
                .replace(
                  /\D/g,
                  ''
                )
                .slice(
                  0,
                  2
                );

          }

        };


      nameInput
        ?.addEventListener(
          'input',
          updatePrintText
        );


      numberInput
        ?.addEventListener(
          'input',
          updatePrintText
        );


      root
        .querySelector(
          '[data-athpp-show-back]'
        )
        ?.addEventListener(
          'click',
          () => {

            if (backImage) {

              setView(
                'back'
              );

            }

          }
        );


      const renderSleeves =
        () => {

          if (!sleeves) {
            return;
          }


          sleeves.innerHTML =
            '';


          const stack = {
            left: 0,
            right: 0
          };


          selectedPatches()
            .forEach(
              (patch) => {

                const side =
                  patch.sleeve ||
                  'left';


                const el =
                  document.createElement(
                    'span'
                  );


                el.className =
                  `athpp__sleeve-patch athpp__sleeve-patch--${side}`;


                el.dataset.stack =
                  String(
                    stack[
                      side
                    ]++
                  );


                if (
                  patch.image
                ) {

                  const img =
                    document.createElement(
                      'img'
                    );


                  img.src =
                    patch.image;


                  img.alt =
                    '';


                  el.appendChild(
                    img
                  );

                }


                sleeves.appendChild(
                  el
                );

              }
            );

        };


      root
        .querySelectorAll(
          '[data-athpp-patch-checkbox]'
        )
        .forEach(
          (box) => {

            box.addEventListener(
              'change',
              () => {

                const patch =
                  box.closest(
                    '[data-athpp-patch]'
                  );


                patch
                  ?.classList.toggle(
                    'is-selected',
                    box.checked
                  );


                renderSleeves();


                updateTotal();


                if (
                  box.checked &&
                  backImage
                ) {

                  setView(
                    'back'
                  );

                }

              }
            );

          }
        );


      const refreshCartUI =
        async (
          cartResponse
        ) => {

          try {

            const cartComponents = [
              ...document.querySelectorAll(
                'cart-items-component'
              )
            ];


            const sectionIds = [
              ...new Set(
                cartComponents
                  .map(
                    (component) =>
                      component.dataset
                        .sectionId
                  )
                  .filter(
                    Boolean
                  )
              )
            ];


            if (
              cartResponse &&
              cartResponse.sections &&
              sectionIds.length &&
              window
                .CartLinesUpdateEvent &&
              typeof window
                .CartLinesUpdateEvent
                .createPromise ===
                'function' &&
              typeof window
                .CartLinesUpdateEvent
                .createCartFromAjaxResponse ===
                'function'
            ) {

              const cart =
                await fetch(
                  '/cart.js',
                  {
                    method:
                      'GET',

                    headers: {
                      Accept:
                        'application/json'
                    },

                    credentials:
                      'same-origin',

                    cache:
                      'no-store'
                  }
                )
                  .then(
                    (response) =>
                      response.json()
                  );


              const deferred =
                window
                  .CartLinesUpdateEvent
                  .createPromise();


              document.dispatchEvent(
                new window
                  .CartLinesUpdateEvent(
                    {
                      action:
                        'add',

                      context:
                        'product',

                      lines:
                        [],

                      promise:
                        deferred.promise
                    }
                  )
              );


              deferred.resolve(
                {
                  cart:
                    window
                      .CartLinesUpdateEvent
                      .createCartFromAjaxResponse(
                        cart
                      ),

                  detail: {
                    sections:
                      cartResponse.sections,

                    items:
                      cart.items,

                    itemCount:
                      cart.item_count,

                    source:
                      'athletix-product',

                    sourceId:
                      root.id,

                    didError:
                      false
                  }
                }
              );


              return cart;

            }


            for (
              const component
              of cartComponents
            ) {

              const sectionId =
                component.dataset
                  .sectionId;


              if (
                !sectionId
              ) {
                continue;
              }


              try {

                const response =
                  await fetch(
                    `/?section_id=${encodeURIComponent(
                      sectionId
                    )}`,
                    {
                      method:
                        'GET',

                      headers: {
                        Accept:
                          'text/html'
                      },

                      credentials:
                        'same-origin',

                      cache:
                        'no-store'
                    }
                  );


                if (
                  !response.ok
                ) {
                  continue;
                }


                const html =
                  await response.text();


                const doc =
                  new DOMParser()
                    .parseFromString(
                      html,
                      'text/html'
                    );


                const fresh =
                  doc.querySelector(
                    `cart-items-component[data-section-id="${sectionId}"]`
                  );


                if (fresh) {

                  component.innerHTML =
                    fresh.innerHTML;

                }


              } catch (error) {

                console.warn(
                  '[ATHLETIX] Cart section refresh failed',
                  error
                );

              }

            }


            const cartResponseJson =
              await fetch(
                '/cart.js',
                {
                  method:
                    'GET',

                  headers: {
                    Accept:
                      'application/json'
                  },

                  credentials:
                    'same-origin',

                  cache:
                    'no-store'
                }
              );


            if (
              !cartResponseJson.ok
            ) {
              return;
            }


            const cart =
              await cartResponseJson
                .json();


            const count =
              Number(
                cart.item_count ||
                0
              );


            document
              .querySelectorAll(
                [
                  '[data-cart-count]',
                  '.cart-count-bubble span[aria-hidden="true"]',
                  '[data-cart-count-bubble]',
                  '[data-cart-count-text]',
                  '[ref="cartItemCount"]'
                ].join(',')
              )
              .forEach(
                (node) => {

                  if (
                    node.children &&
                    node.children.length >
                      0 &&
                    !node.matches(
                      '.cart-count-bubble span'
                    )
                  ) {
                    return;
                  }


                  node.textContent =
                    String(
                      count
                    );

                }
              );


            document.dispatchEvent(
              new CustomEvent(
                'athletix:cart-updated',
                {
                  bubbles:
                    true,

                  detail:
                    cart
                }
              )
            );


            return cart;


          } catch (error) {

            console.warn(
              '[ATHLETIX] Cart UI refresh failed',
              error
            );

          }

        };
              const addToCart =
        async (
          event
        ) => {

          event
            ?.preventDefault();


          if (submitting) {
            return;
          }


          updateVariantUI();


          if (
            !selectedVariant ||
            !selectedVariant.available
          ) {

            if (message) {

              message.textContent =
                'Please choose an available size.';


              message.classList.remove(
                'is-success'
              );

            }


            return;
          }


          /*
           * FAN / PLAYER REQUIRED ONLY IF
           * THIS PRODUCT ACTUALLY HAS THE SELECTOR.
           *
           * Baby Body Suits and Long Sleeve products
           * have no selector because Liquid removes it,
           * so they will never be blocked here.
           */

          if (
            isPersonalizationOn() &&
            printVersionInputs.length > 0 &&
            !getSelectedPrintVersion()
          ) {

            if (
              printVersionError
            ) {
              printVersionError.hidden =
                false;
            }


            if (message) {

              message.textContent =
                'Please choose Fan Version or Player Version.';


              message.classList.remove(
                'is-success'
              );

            }


            printVersionGroup
              ?.scrollIntoView({
                behavior:
                  'smooth',

                block:
                  'center'
              });


            const firstVersionInput =
              printVersionInputs[0];


            if (
              firstVersionInput
            ) {

              window.setTimeout(
                () =>
                  firstVersionInput
                    .focus(),

                350
              );

            }


            return;

          }


          const quantity =
            getQuantity();


          const properties =
            {};


          if (
            isPersonalizationOn()
          ) {

            const name =
              (
                nameInput?.value ||
                ''
              )
                .trim();


            const number =
              (
                numberInput?.value ||
                ''
              )
                .trim();


            if (name) {

              properties[
                'Name'
              ] =
                name;

            }


            if (number) {

              properties[
                'Number'
              ] =
                number;

            }


            /*
             * Only add Jersey Version if
             * Fan / Player exists on this product.
             */

            if (
              printVersionInputs.length >
                0
            ) {

              properties[
                'Jersey Version'
              ] =
                getSelectedPrintVersion();

            }

          }


          const items = [
            {
              id:
                Number(
                  selectedVariant.id
                ),

              quantity,

              properties
            }
          ];


          /* ======================================================
             REAL $3 NAME & NUMBER PRINTING CHARGE
             Added as a separate Shopify line item when printing is ON.
          ====================================================== */

      /* ======================================================
   REAL $3 NAME & NUMBER PRINTING CHARGE
   Adds the global Shopify printing product to the cart.
====================================================== */

if (isPersonalizationOn()) {

  properties['Printing'] =
    'Name & Number';

  items.push({
    id: printAddonVariantId,
    quantity: quantity,

    properties: {
      'For jersey':
        root.dataset.productTitle ||
        'Jersey',

      'Service':
        'Name & Number Printing',

      'Name':
        (nameInput?.value || '').trim(),

      'Number':
        (numberInput?.value || '').trim()
    }
  });

}


          selectedPatches()
            .forEach(
              (patch) => {

                items.push(
                  {
                    id:
                      patch.variantId,

                    quantity,

                    properties: {
                      'For jersey':
                        root.dataset
                          .productTitle ||
                        'Jersey',

                      Patch:
                        patch.title,

                      Sleeve:
                        patch.sleeve
                    }
                  }
                );

              }
            );


          submitting =
            true;


          if (addButton) {

            addButton.disabled =
              true;

          }


          if (addLabel) {

            addLabel.textContent =
              'ADDING…';

          }


          if (message) {

            message.textContent =
              '';


            message.classList.remove(
              'is-success'
            );

          }


          try {

            const cartSectionIds = [
              ...new Set(
                [
                  ...document.querySelectorAll(
                    'cart-items-component[data-section-id]'
                  )
                ]
                  .map(
                    (component) =>
                      component.dataset
                        .sectionId
                  )
                  .filter(
                    Boolean
                  )
              )
            ];


            const response =
              await fetch(
                '/cart/add.js',
                {
                  method:
                    'POST',

                  headers: {
                    'Content-Type':
                      'application/json',

                    Accept:
                      'application/json'
                  },

                  credentials:
                    'same-origin',

                  body:
                    JSON.stringify(
                      {
                        items,

                        sections:
                          cartSectionIds
                            .join(
                              ','
                            ),

                        sections_url:
                          window
                            .location
                            .pathname
                      }
                    )
                }
              );


            const payload =
              await response
                .json()
                .catch(
                  () =>
                    ({})
                );


            if (
              !response.ok ||
              payload.status
            ) {

              const errorText =
                payload.description ||
                payload.message ||
                'This item could not be added to the cart.';


              throw new Error(
                errorText
              );

            }


            if (addLabel) {

              addLabel.textContent =
                'ADDED ✓';

            }


            if (message) {

              message.textContent =
                'Added to cart.';


              message.classList.add(
                'is-success'
              );

            }


            await refreshCartUI(
              payload
            );


            if (
              typeof window
                .athletixSyncHorizonCart ===
                'function'
            ) {

              await window
                .athletixSyncHorizonCart();

            }


            window.setTimeout(
              () => {

                if (addLabel) {

                  addLabel.textContent =
                    'ADD TO CART';

                }


                if (addButton) {

                  addButton.disabled =
                    !selectedVariant
                      ?.available;

                }

              },

              1100
            );


          } catch (error) {

            console.error(
              '[ATHLETIX] Add to cart failed:',
              error
            );


            if (addLabel) {

              addLabel.textContent =
                'TRY AGAIN';

            }


            if (message) {

              message.textContent =
                error?.message ||
                'Could not add this item. Please try again.';


              message.classList.remove(
                'is-success'
              );

            }


            if (addButton) {

              addButton.disabled =
                false;

            }


          } finally {

            submitting =
              false;

          }

        };


      form
        ?.addEventListener(
          'submit',
          addToCart
        );


      updatePrintText();

      renderPersonalization();

      updateVariantUI();

      setView(
        'front'
      );

    };


  const initAll =
    (
      scope = document
    ) => {

      if (
        scope.matches?.(
          ROOT_SELECTOR
        )
      ) {

        init(
          scope
        );

      }


      scope
        .querySelectorAll?.(
          ROOT_SELECTOR
        )
        .forEach(
          init
        );

    };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () =>
        initAll()
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) =>
      initAll(
        event.target
      )
  );

})();


(() => {
  'use strict';


  const CART_FORM =
    '[data-athpp-form]';


  const getCart =
    async () => {

      const response =
        await fetch(
          '/cart.js',
          {
            method:
              'GET',

            headers: {
              Accept:
                'application/json'
            },

            credentials:
              'same-origin',

            cache:
              'no-store'
          }
        );


      if (
        !response.ok
      ) {

        throw new Error(
          'Could not load Shopify cart'
        );

      }


      return response.json();

    };


  const refreshCartDrawer =
    async () => {

      try {

        const response =
          await fetch(
            `${window.location.pathname}?section_id=cart-drawer-section&_=${Date.now()}`,
            {
              method:
                'GET',

              headers: {
                Accept:
                  'text/html'
              },

              credentials:
                'same-origin',

              cache:
                'no-store'
            }
          );


        if (
          !response.ok
        ) {

          throw new Error(
            `Cart drawer section returned ${response.status}`
          );

        }


        const html =
          await response.text();


        const parser =
          new DOMParser();


        const documentFragment =
          parser.parseFromString(
            html,
            'text/html'
          );


        const newWrapper =
          documentFragment
            .querySelector(
              '#shopify-section-cart-drawer-section'
            );


        const currentWrapper =
          document
            .querySelector(
              '#shopify-section-cart-drawer-section'
            );


        if (
          newWrapper &&
          currentWrapper
        ) {

          currentWrapper
            .replaceWith(
              newWrapper
            );

        } else {

          const newDrawer =
            documentFragment
              .querySelector(
                '#cart-drawer'
              );


          const currentDrawer =
            document
              .querySelector(
                '#cart-drawer'
              );


          if (
            newDrawer &&
            currentDrawer
          ) {

            currentDrawer
              .replaceWith(
                newDrawer
              );

          }

        }


        const cart =
          await getCart();


        const count =
          Number(
            cart.item_count ||
            0
          );


        document
          .querySelectorAll(
            [
              '.theme-drawer__badge',
              '[data-cart-count]',
              '[data-cart-count-bubble]',
              '[data-cart-count-text]',
              '.cart-count-bubble span[aria-hidden="true"]',
              '[ref="cartItemCount"]'
            ].join(',')
          )
          .forEach(
            (node) => {

              if (
                node.children &&
                node.children.length >
                  0 &&
                !node.classList
                  .contains(
                    'theme-drawer__badge'
                  )
              ) {
                return;
              }


              node.textContent =
                String(
                  count
                );


              node.classList.toggle(
                'visually-hidden',
                count === 0
              );

            }
          );


        document.dispatchEvent(
          new CustomEvent(
            'athletix:cart-drawer-synced',
            {
              bubbles:
                true,

              detail:
                cart
            }
          )
        );


        if (
          typeof window
            .athletixSyncHorizonCart ===
            'function'
        ) {

          await window
            .athletixSyncHorizonCart(
              cart
            );

        }


        console.log(
          '[ATHLETIX] Horizon cart drawer synced:',
          count
        );


        return cart;


      } catch (error) {

        console.error(
          '[ATHLETIX] Horizon drawer sync failed:',
          error
        );


        return null;

      }

    };


  const waitForCartIncrease =
    async (
      previousCount,
      expectedIncrease
    ) => {

      const minimumExpected =
        previousCount +
        Math.max(
          1,
          Number(
            expectedIncrease
          ) ||
            1
        );


      for (
        let attempt = 0;
        attempt < 30;
        attempt++
      ) {

        try {

          const cart =
            await getCart();


          const currentCount =
            Number(
              cart.item_count ||
              0
            );


          if (
            currentCount >=
            minimumExpected
          ) {

            return cart;

          }


        } catch (error) {

          console.warn(
            '[ATHLETIX] Waiting for Shopify cart...',
            error
          );

        }


        await new Promise(
          (resolve) =>
            window.setTimeout(
              resolve,
              150
            )
        );

      }


      return getCart()
        .catch(
          () =>
            null
        );

    };


  const initialize =
    (form) => {

      if (
        !form ||
        form.dataset
          .athletixDrawerSync ===
          'true'
      ) {
        return;
      }


      form.dataset
        .athletixDrawerSync =
        'true';


      form.addEventListener(
        'submit',

        async () => {

          let beforeCart;


          try {

            beforeCart =
              await getCart();

          } catch {

            beforeCart = {
              item_count:
                0
            };

          }


          const root =
            form.closest(
              '[data-athpp]'
            );


          const quantityInput =
            root
              ?.querySelector(
                '[data-athpp-quantity]'
              );


          const quantity =
            Math.max(
              1,
              parseInt(
                quantityInput?.value ||
                  '1',
                10
              ) ||
                1
            );


          const selectedPatchCount =
            root
              ? [
                  ...root.querySelectorAll(
                    '[data-athpp-patch-checkbox]:checked'
                  )
                ].length
              : 0;


          const printingEnabled =
            root
              ?.querySelector(
                '[data-athpp-print-toggle]'
              )
              ?.getAttribute(
                'aria-checked'
              ) === 'true';


          const expectedIncrease =
            quantity *
            (
              1 +
              selectedPatchCount +
              (printingEnabled ? 1 : 0)
            );


          const previousCount =
            Number(
              beforeCart.item_count ||
              0
            );


          await waitForCartIncrease(
            previousCount,
            expectedIncrease
          );


          await refreshCartDrawer();

        },

        true
      );

    };


  const initializeAll =
    (
      scope = document
    ) => {

      if (
        scope.matches?.(
          CART_FORM
        )
      ) {

        initialize(
          scope
        );

      }


      scope
        .querySelectorAll?.(
          CART_FORM
        )
        .forEach(
          initialize
        );

    };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () =>
        initializeAll()
    );

  } else {

    initializeAll();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initializeAll(
        event.target
      );

    }
  );

})();